var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.39 262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#42210b;}.cls-2{fill:#810000;}.cls-3{fill:#f2f2f2;}.cls-4{fill:#fff;}.cls-5,.cls-7{fill:#006837;}.cls-5{opacity:0.2;}.cls-6{fill:#009245;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 10ok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.87,0C5.08,0,.38,7.65.38,17.08V246.72c11.51-45.14,31.28-101.83,59.79-113.43C99.7,117.2,110.42,81.56,125.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.42.45C3.32.45,0,5.85,0,12.52V174.89c8.14-31.91,22.11-72,42.28-80.2C70.22,83.31,77.8,58.11,88.38.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.38,129.84V252.43a9.56,9.56,0,0,1-9.57,9.57H74.89a9.57,9.57,0,0,1-9.57-9.57V103.57A9.57,9.57,0,0,1,74.89,94h73.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.39,129.82l-25.66,0a9.57,9.57,0,0,1-9.57-9.56l0-26.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 148.49,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 90.3,
    y: 148.49,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 166.65,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 90.3,
    y: 166.65,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 184.81,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 90.3,
    y: 184.81,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 202.97,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 90.3,
    y: 202.97,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 221.14,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 90.3,
    y: 221.14,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.41,
    y: 239.3,
    width: 5.68,
    height: 5.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 90.3,
    y: 239.3,
    width: 82.86,
    height: 5.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "37.45 129.25 49.37 109.33 60.86 136.59 100.38 75.1 108.79 90.64 116.76 105.36 58.44 150.91 37.45 129.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "60.6 142.48 110.97 94.66 116.76 105.36 58.44 150.91 37.45 129.25 43.66 118.87 60.6 142.48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/BG_2.1a79cfa68113433f800c9d4b88086821.svg";
export { ForwardRef as ReactComponent };